var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.136,
    height: 49.136,
    viewBox: "0 0 49.136 49.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4",
    "data-name": "Raggruppa 4",
    transform: "translate(-203 -370)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-o",
    transform: "translate(203 370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_291",
    "data-name": "Tracciato 291",
    d: "M27.437,11.765A2.233,2.233,0,0,0,24.391,8.5l-6.535,6.091L11.765,8.053A2.233,2.233,0,0,0,8.5,11.1l6.091,6.535L8.053,23.725A2.233,2.233,0,1,0,11.1,26.993L17.634,20.9l6.091,6.535a2.233,2.233,0,0,0,3.268-3.046L20.9,17.856Z",
    transform: "translate(6.823 6.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_292",
    "data-name": "Tracciato 292",
    d: "M1,25.568A24.568,24.568,0,1,1,25.568,50.136,24.568,24.568,0,0,1,1,25.568Zm24.568,20.1a20.1,20.1,0,1,1,20.1-20.1A20.1,20.1,0,0,1,25.568,45.669Z",
    transform: "translate(-1 -1)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.606148449c81bd378497d2421c9eb032.svg";
export { ForwardRef as ReactComponent };